﻿const registrationTypeTypes = {
	Myself: {
		name: "Individual (Myself)",
		value: "Individual (Myself)"
	},
	SomeoneElse: {
		name: "Individual (Someone Else)",
		value: "Individual (Someone Else)"
	},
	Joint: {
		name: "Joint Holding(s)",
		value: "Joint Holding(s)"
	},
	Trust: {
		name: "Trust",
		value: "Trust"
	},
	Partnership: {
		name: "Partnership",
		value: "Partnership"
	},
	Company: {
		name: "Company/Corporation",
		value: "Company/Corporation"
	},
	Insto: {
		name: "Institutional Investor",
		value: "Institutional Investor"
	},
	SMSF: {
		name: "Self Managed Super Fund",
		value: "Self Managed Super Fund"
	}
};

const registrationTypeOptions = [
	{ name: registrationTypeTypes.Myself.name, value: registrationTypeTypes.Myself.value },
	{ name: registrationTypeTypes.SomeoneElse.name, value: registrationTypeTypes.SomeoneElse.value },
	{ name: registrationTypeTypes.Joint.name, value: registrationTypeTypes.Joint.value },
	{ name: registrationTypeTypes.Trust.name, value: registrationTypeTypes.Trust.value },
	{ name: registrationTypeTypes.Partnership.name, value: registrationTypeTypes.Partnership.value },
	{ name: registrationTypeTypes.Company.name, value: registrationTypeTypes.Company.value },
	{ name: registrationTypeTypes.Insto.name, value: registrationTypeTypes.Insto.value },
	{ name: registrationTypeTypes.SMSF.name, value: registrationTypeTypes.SMSF.value }
];

const registrationTypes = {
	types: registrationTypeTypes,
	options: registrationTypeOptions
};

export default registrationTypes;
